<template>
  <div class="mobile-menu md:hidden">
    <div class="mobile-menu-bar">
      <a href="javascript:;" @click="ModuleAll" class="flex mr-auto">
        <img
          :src="logoWhite"
          alt=""
          class="w-20"
        />
        <!-- <img src="@/assets/images/logo.svg" class="w-6" alt="" />
        <span class="text-white text-lg ml-3"> WorkFlow </span> -->
      </a>
      <div class="flex flex-row">
        <div class="intro-x dropdown w-8 h-8 mr-4">
          <div
            class="
              dropdown-toggle
              w-8
              h-8
              rounded-full
              overflow-hidden
              shadow-lg
              image-fit
              zoom-in
              scale-110
              bg-blue-50
            "
            role="button"
            aria-expanded="false"
          >
            <img
              :src="employeeImage"
              alt=""
              v-show="employeeImage"
              @error="$h.imgError"
            />
          </div>
          <div class="dropdown-menu w-56">
            <div
              class="
                dropdown-menu__content
                box
                bg-theme-26
                dark:bg-dark-6
                text-white
              "
            >
              <div class="p-4 border-b border-theme-27 dark:border-dark-3">
                <div class="font-medium">
                  {{ fullname }}
                </div>
              </div>
              <!-- <div class="p-02">
                <a
                  href=""
                  class="
                    flex
                    items-center
                    p-2
                    transition
                    duration-300
                    ease-in-out
                    hover:bg-theme-1
                    dark:hober:bg-dark-3
                    rounded-md
                  "
                >
                  <UserIcon class="w-4 h-4 mr-2" /> Profile
                </a>
                <a
                  href=""
                  class="
                    flex
                    items-center
                    p-2
                    transition
                    duration-300
                    ease-in-out
                    hover:bg-theme-1
                    dark:hober:bg-dark-3
                    rounded-md
                  "
                >
                  <LockIcon class="w-4 h-4 mr-2" /> Reset Password
                </a>
                <a
                  href=""
                  class="
                    flex
                    items-center
                    p-2
                    transition
                    duration-300
                    ease-in-out
                    hover:bg-theme-1
                    dark:hober:bg-dark-3
                    rounded-md
                  "
                >
                  <HelpCircleIcon class="w-4 h-4 mr-2" /> Help
                </a>
              </div> -->
              <div class="p-2 border-t border-theme-28 dark:border-dark-3">
                <router-link
                  tag="a"
                  :to="{ name: 'logout' }"
                  class="
                    flex
                    items-center
                    p-2
                    transition
                    duration-300
                    ease-in-out
                    hover:bg-theme-1
                    dark:hover:bg-dark-3
                    rounded-md
                  "
                >
                  <ToggleRightIcon class="w-4 h-4 mr-2" />Logout
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <BarChart2Icon
          class="w-8 h-8 text-theme-29 transform -rotate-90"
          @click="toggleMobileMenu"
        />
      </div>
    </div>
    <transition @enter="enter" @leave="leave">
      <ul v-if="activeMobileMenu" class="border-t border-theme-29 py-4">
        <template
          v-for="(menu, menuKey) in formattedMenu"
          :key="menu + menuKey"
        >
          <li class="menu_devider">
            <a href="javascript:;" class="menu" @click="linkTo(menu, router)"
              ><ActivityIcon class="top-menu__sub-icon mr-3" />{{ menu.title }}
              <span
                v-if="menu.pageName == 'memo' && countMemo > 0"
                class="px-2 py-1 rounded-full ml-2 bg-theme-6 text-white"
                >{{ countMemo }}</span
              >
              <span
                v-if="menu.pageName == 'pv' && countAll.pv > 0"
                class="px-2 py-1 rounded-full ml-2 bg-theme-6 text-white"
                >{{ countAll.pv }}</span
              >
              <span
                v-if="menu.pageName == 'ca' && countAll.ca > 0"
                class="px-2 py-1 rounded-full ml-2 bg-theme-6 text-white"
                >{{ countAll.ca }}</span
              >
              <span
                v-if="menu.pageName == 'cl' && countAll.cl > 0"
                class="px-2 py-1 rounded-full ml-2 bg-theme-6 text-white"
                >{{ countAll.cl }}</span
              >
              <span
                v-if="menu.pageName == 'pr' && countAll.pr > 0"
                class="px-2 py-1 rounded-full ml-2 bg-theme-6 text-white"
                >{{ countAll.pr }}</span
              >
              <span
                v-if="menu.pageName == 'po' && countAll.po > 0"
                class="px-2 py-1 rounded-full ml-2 bg-theme-6 text-white"
                >{{ countAll.po }}</span
              >
              <span
                v-if="menu.pageName == 'gr' && countAll.gr > 0"
                class="px-2 py-1 rounded-full ml-2 bg-theme-6 text-white"
                >{{ countAll.gr }}</span
              >
            </a>
          </li>
        </template>
        <!-- <template v-for="(menu, menuKey) in formattedMenu">
          <li
            class="menu_devider my-6"
            v-if="menu == 'devider'"
            :key="menu + menuKey"
          ></li>
          <li v-else :key="menu + menuKey">
            <a
              href=""
              class="menu"
              :class="{
                'menu--active': menu.active,
                'menu--open': menu.activeDropdown
              }"
              @click="linkTo(menu, router)"
            >
              <div class="menu__icon">
                <component :is="menu.icon" />
              </div>
              <div class="menu__title">
                {{ menu.title }}
                <div
                  v-if="menu.subMenu"
                  class="menu__sub-icon"
                  :class="{ 'transform rotate-180': menu.activeDropdown }"
                >
                  <ChevronDownIcon />
                </div>
              </div>
            </a>

            <transition @enter="enter" @leave="leave">
              <ul v-if="menu.subMenu && menu.activeDropdown">
                <li
                  v-for="(subMenu, subMenuKey) in menu.subMenu"
                  :key="subMenuKey"
                >
                  <a
                    href=""
                    class="menu"
                    :class="{ 'menu--active': subMenu.active }"
                    @click="linkTo(subMenu, router)"
                  >
                    <div class="menu__icon">
                      <ActivityIcon />
                    </div>
                    <div class="menu__title">
                      {{ subMenu.title }}
                      <div
                        v-if="subMenu.subMenu"
                        class="menu__sub-item"
                        :class="{
                          'transform rotate-180': subMenu.activeDropdown
                        }"
                      >
                        <ChevronDownIcon />
                      </div>
                    </div>
                  </a>
                  <transition @enter="enter" @leave="leave">
                    <ul v-if="subMenu.subMenu && subMenu.activeDropdown">
                      <li
                        v-for="(lastSubMenu, lastSubMenuKey) in subMenu.subMenu"
                        :key="lastSubMenuKey"
                      >
                        <a
                          href="javascript:;"
                          class="menu"
                          :class="{ 'menu--active': lastSubMenu.active }"
                          @click="linkTo(lastSubMenu, router)"
                        >
                          <div class="menu__icon">
                            <ZapIcon />
                          </div>
                          <div class="menu__title">
                            {{ lastSubMenu.title }}
                          </div>
                        </a>
                      </li>
                    </ul>
                  </transition>
                </li>
              </ul>
            </transition>
          </li>
        </template> -->
      </ul>
    </transition>
  </div>
</template>

<script>
import { defineComponent, computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import { helper as $h } from '@/utils/helper'
import {
  activeMobileMenu,
  toggleMobileMenu,
  linkTo,
  enter,
  leave
} from './index'
import { nestedMenu } from '@/layouts/top-menu'
export default defineComponent({
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const formattedMenu = ref([])
    const mobileMenu = computed(() =>
      nestedMenu(store.state.topMenu.menu, route)
    )
    const user = computed(() => store.state.auth.info)
    const fullname = user.value.fullname
    const employeeImage = user.value.employeeImage
    const logoWhite = process.env.VUE_APP_IMAGE_LOGO_WHITE
    const ModuleAll = () => {
      router.push({ name: 'all' })
    }

    watch(
      computed(() => route.path),
      () => {
        formattedMenu.value = $h.toRaw(mobileMenu.value)
      }
    )

    const countMemo = computed(() => store.state.memo.countMyDoc)
    const countAll = computed(() => store.state.global.docWait)

    onMounted(() => {
      formattedMenu.value = $h.toRaw(mobileMenu.value)
    })

    return {
      activeMobileMenu,
      toggleMobileMenu,
      formattedMenu,
      ModuleAll,
      router,
      fullname,
      employeeImage,
      logoWhite,
      linkTo,
      enter,
      leave,
      countMemo,
      countAll,
      $h
    }
  }
})
</script>
